/* eslint-disable import/no-default-export */
import { Action, actionCreator } from 'app/gamma/src/util/actions';
import { createReducer } from 'app/gamma/src/util/reducers';
import { TeamType } from 'app/gamma/src/modules/state/models/teams';

// Action types

const SET_OVERLAY = Symbol('ui/SET_OVERLAY');
const REMOVE_OVERLAY = Symbol('ui/REMOVE_OVERLAY');

export enum OverlayType {
  CreateBoard = 'create_board',
  ClosedBoards = 'closed_boards',
  CreateTeam = 'create_team',
}

type SetOverlayAction = Action<
  typeof SET_OVERLAY,
  {
    overlayType: OverlayType | null;
    teamType?: TeamType | null;
  }
>;
type RemoveOverlayAction = Action<typeof REMOVE_OVERLAY, null>;

interface OverlayPayload {
  overlayType: string | null;
  teamType: TeamType | null;
}

export type OverlayState = OverlayPayload;

// Reducer
const initialState: OverlayState = {
  overlayType: null,
  teamType: null,
};

export default createReducer(initialState, {
  [SET_OVERLAY](state: OverlayState, { payload }: SetOverlayAction) {
    return payload;
  },

  [REMOVE_OVERLAY]() {
    return initialState;
  },
});

// Action creators
export const setOverlay = actionCreator<SetOverlayAction>(SET_OVERLAY);
export const removeOverlay = actionCreator<RemoveOverlayAction>(REMOVE_OVERLAY);
